import { castToMoment } from './castToMoment';

export function formatDate(value, short = false) {


    if (value === 0 || value === '' || value === undefined || value === null) {
        return '';
    }

    const momentVal = castToMoment(value);

    if (momentVal.isValid()) {
        return momentVal.format(short ? 'MMM D YY, h:mm:ss a' : 'MMM D YYYY, h:mm:ss a z');
    }

    if (!isNaN(parseInt(value))) {
        value = parseInt(value);
        const momentValShort = castToMoment(value);
        if (momentValShort.isValid()) {
            return momentValShort.format(short ? 'MMM D YY, h:mm:ss a' : 'MMM D YYYY, h:mm:ss a z');
        }
    }

    return '';
}
